import { render, staticRenderFns } from "./AddElementToVenue.vue?vue&type=template&id=fa84f76c&"
import script from "./AddElementToVenue.vue?vue&type=script&lang=js&"
export * from "./AddElementToVenue.vue?vue&type=script&lang=js&"
import style0 from "./AddElementToVenue.vue?vue&type=style&index=0&id=fa84f76c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports